import {useQuery} from 'react-query'
import {isNotEmpty, QUERIES} from '../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getPostCategoryById} from '../core/_requests'
import {PostCategoryEditModalForm} from './PostCategoryEditModalForm'

const PostCategoryEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: postCategory,
    error,
  } = useQuery(
    `${QUERIES.POST_CATEGORY_LIST}-${itemIdForUpdate}`,
    () => {
      const postCategory = getPostCategoryById(itemIdForUpdate)
      return postCategory
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <PostCategoryEditModalForm isUserLoading={isLoading} postCategory={{id: undefined}} />
  }
  if (!isLoading && !error && postCategory) {
    return <PostCategoryEditModalForm isUserLoading={isLoading} postCategory={postCategory} />
  }

  return null
}

export {PostCategoryEditModalFormWrapper}
